import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

import { Main } from 'Containers';
import { errorToast, createToast, toastType } from 'Common/ToastHelper';
import { LoadingPage } from 'Components/loading/LoadingPage';
import { ReactTableWrapperColumnProperties } from 'Common/Constants';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { ManageTruckRoutesListEnum } from 'Common/FieldEnum';
import { HeaderLeftAlign } from 'Common/Constants/table';

import ManageTruckRouteListsComponent from './../../components/managetruckrouteslist/ManageTruckRoutesList';
import * as Selectors from '../../state/managetruckrouteslist/selectors';
import * as actions from '../../state/managetruckrouteslist/actions';
import { BASE_URL } from './../../helper/index';

class ManageTruckRoutesList extends Component {
  static propTypes = {
    truckRouteListData: PropTypes.array.isRequired,
    truckRouteListDataLoading: PropTypes.bool.isRequired,
    truckRouteListDataLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    printTruckRouteDetailLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    printTruckRouteDetailLoading: PropTypes.bool.isRequired,
    deleteTruckRouteSuccess: PropTypes.object,
    deleteTruckRouteLoading: PropTypes.bool.isRequired,
    deleteTruckRouteLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
  };

  static defaultProps = {
    truckRouteListDataLoadingError: null,
    printTruckRouteDetailLoadingError: null,
    deleteTruckRouteSuccess: null,
    deleteTruckRouteLoadingError: null,
  };
  state = {
    showDeleteConfirm: false,
    selectedRoute: null,
  };
  reactTableWrapperInstance = React.createRef();

  componentDidMount() {
    this.props.getTruckRoute();
  }

  componentDidUpdate(prevProps) {
    const {
      clearTruckRouteErrors,
      deleteTruckRouteSuccess,
      clearDeleteTruckRouteSuccess,
    } = this.props;
    if (
      errorToast(this.props, prevProps, 'truckRouteListDataLoadingError') ||
      errorToast(this.props, prevProps, 'printTruckRouteDetailLoadingError') ||
      errorToast(this.props, prevProps, 'deleteTruckRouteLoadingError')
    ) {
      clearTruckRouteErrors();
    }
    if (
      deleteTruckRouteSuccess &&
      deleteTruckRouteSuccess !== prevProps.deleteTruckRouteSuccess
    ) {
      createToast(
        toastType.success,
        'Success',
        deleteTruckRouteSuccess.Data,
        true
      );
      clearDeleteTruckRouteSuccess();
    }
  }
  componentWillUnmount() {
    toast.dismiss();
  }

  getMenuOptions = gridProps => {
    const { row } = gridProps;
    let menuOptions = [
      {
        icon: 'pencil',
        text: 'View/Edit',
        handler: () => this.onEditClick(row),
      },
      {
        icon: 'print',
        text: 'Print',
        handler: () => this.onPrintClick(row),
      },
      {
        icon: 'trash',
        text: 'Delete',
        className: 'danger',
        handler: () => this.onDeleteClick(row),
      },
    ];
    return menuOptions;
  };
  columns = [
    {
      Header: () => <span className="ml-5">Truck Route</span>,
      accessor: ManageTruckRoutesListEnum.Description,
      width: 700,
      ...HeaderLeftAlign,
      ...ReactTableWrapperColumnProperties,
    },
    {
      Header: () => <span className="ml-5">Type</span>,
      accessor: ManageTruckRoutesListEnum.Type,
      ...HeaderLeftAlign,
      ...ReactTableWrapperColumnProperties,
    },
    {
      resizable: false,
      width: 50,
      sortable: false,
      Cell: gridProps => {
        return GridContextMenu({
          gridProps,
          options: this.getMenuOptions(gridProps),
        });
      },
    },
  ];

  onEditClick = gridProps => {
    const { _original } = gridProps;
    this.props.history.push(
      `${BASE_URL}/route/1/${_original[ManageTruckRoutesListEnum.Id]}`
    );
  };

  onPrintClick = gridProps => {
    const { _original } = gridProps;
    this.props.printTruckRouteDetail(_original[ManageTruckRoutesListEnum.Id]);
  };

  onDeleteClick = gridProps => {
    const { _original } = gridProps;
    this.setState({
      selectedRoute: _original,
      showDeleteConfirm: true,
    });
  };

  clearFilters = () => {
    this.reactTableWrapperInstance &&
      this.reactTableWrapperInstance.clearTableState();
  };
  setReactTableWrapperInstance = ref => {
    this.reactTableWrapperInstance = ref;
  };

  handleDeleteDialog = result => {
    if (result) {
      this.props.deleteTruckRoute(
        this.state.selectedRoute[ManageTruckRoutesListEnum.Id]
      );
    }
    this.setState({ showDeleteConfirm: false });
  };
  render() {
    const {
      truckRouteListData,
      printTruckRouteDetailLoading,
      deleteTruckRouteLoading,
      truckRouteListDataLoading,
    } = this.props;
    return (
      <Fragment>
        {null && <LoadingPage />}
        <Main shouldNotUsePageWidth>
          <ManageTruckRouteListsComponent
            getMenuOptions={this.getMenuOptions}
            clearFilters={this.clearFilters}
            truckRouteListData={truckRouteListData}
            printTruckRouteDetailLoading={printTruckRouteDetailLoading}
            deleteTruckRouteLoading={deleteTruckRouteLoading}
            columns={this.columns}
            truckRouteListDataLoading={truckRouteListDataLoading}
            showDeleteConfirm={this.state.showDeleteConfirm}
            selectedRoute={this.state.selectedRoute}
            handleDeleteDialog={this.handleDeleteDialog}
            setReactTableWrapperInstance={this.setReactTableWrapperInstance}
          />
        </Main>
      </Fragment>
    );
  }
}
const mapStateToProps = state => {
  return {
    truckRouteListData: Selectors.getTruckRouteListWithType(state),
    truckRouteListDataLoading: Selectors.getTruckRouteListDataLoading(state),
    truckRouteListDataLoadingError: Selectors.getTruckRouteListDataLoadingError(
      state
    ),
    printTruckRouteDetailLoadingError: Selectors.getPrintTruckRouteDetailLoadingError(
      state
    ),
    printTruckRouteDetailLoading: Selectors.getPrintTruckRouteDetailLoading(
      state
    ),
    deleteTruckRouteSuccess: Selectors.getDeleteTruckRouteSuccess(state),
    deleteTruckRouteLoading: Selectors.getDeleteTruckRouteLoading(state),
    deleteTruckRouteLoadingError: Selectors.getDeleteTruckRouteLoadingError(
      state
    ),
  };
};

const mapDispatchToProps = {
  ...actions,
};

export const ManageTruckRoutesComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageTruckRoutesList);



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/containers/managetruckrouteslist/ManageTruckRoutesList.js